import { createSlice } from '@reduxjs/toolkit'
import { START_LOADING, STOP_LOADING } from '../actions/types';

const initialState = {
  loading: false
};

const loaderReducerSlice = createSlice({
  name:"loader",
  initialState,
  reducers:{
    startLoading(state){
      return{
        ...state,
        loading: true
      } 
    },
    stopLoading(state){
      return{
        ...state,
        loading: false
      }
    },
  }
})

export const loaderReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING: {
      return {
        ...state,
        loading: true
      };
    }
    case STOP_LOADING: {
      return {
        ...state,
        loading: false
      };
    }
    default:
      return state;
  }
};


export const loaderReducerAction = loaderReducerSlice.actions
export const loaderReducers = loaderReducerSlice.reducer